import { ColumnProps } from 'antd/lib/table'
import KTable from 'app/components/Modules/Table/KTable'
import { RecordType, TableProps } from 'app/constants/GlobalTypes'
import * as React from 'react'
import { useIntl } from 'react-intl'

import Item from './Mobile/Item'

const DocumentTable: React.FC<TableProps<IDocument>> = ({ params, onRowClick, ...others }) => {
  const { formatMessage } = useIntl()

  const columns: ColumnProps<IDocument>[] = [
    {
      title: formatMessage({ id: 'project.detail.documents.table.header.type' }),
      dataIndex: 'document_type',
      ellipsis: true
    },
    {
      title: formatMessage({ id: 'project.detail.documents.table.header.name' }),
      dataIndex: 'name',
      ellipsis: true
    },
    {
      title: formatMessage({ id: 'project.detail.documents.table.header.created_by' }),
      dataIndex: 'created_by',
      ellipsis: true
    },
    {
      title: formatMessage({ id: 'project.detail.documents.table.header.created_at' }),
      dataIndex: 'created_at'
    }
  ]

  return (
    <KTable<IDocument>
      params={params}
      recordType={RecordType.document}
      onRowClick={onRowClick}
      columns={columns}
      renderMobileRow={(record: IDocument) => <Item member={record} />}
      {...others}
    />
  )
}

export default DocumentTable
